'use client';

import { useEffect } from 'react';
import { ids } from '@/data/e2eTestTokens';
import { useT } from './i18n/client';

const url =
  process.env.NODE_ENV === 'production' ? 'https://go.uspace.city' : 'http://localhost:3000';

export default function Error({ error }) {
  const { t } = useT();
  useEffect(() => {
    fetch(`${url}/api/error`, {
      method: 'POST',
      body: JSON.stringify({
        message: error.message ?? '未知錯誤',
        page: window.location.pathname,
      }),
    });
  }, []);

  return (
    <div
      id={ids.errorMessage}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1',
        paddingTop: '80px',
      }}
    >
      {t('errorPrompt')}
      <a href="/home">{t('backToHome')}</a>
    </div>
  );
}
